const prodNweaConfig = {
  name: 'prod',
  rootUrl: 'https://login.mapnwea.org/ui/',
  loginUrl: 'https://login.mapnwea.org/ui/login/',
  loggedInUrl: 'https://auth.nwea.org/adult/verifyHcpAuthorizationCode',
  loggedOutUrl: 'https://platform.heinemann.com/ui/login/logged-out/',
  helpUrl: 'https://connection.nwea.org/s/support?language=en_US',
  privacyPolicyUrl: 'https://www.nwea.org/policy/privacy-and-terms/',
  termsAndConditionsUrl:
    'https://www.nwea.org/policy/nwea-platform-terms-of-use/',
  forgotPasswordUrlPath: '/ui/login/forgot-password/',
  requestSigninDetailsUrlPath: '/ui/login/request-signin-details/',
  restIdsGridApi: 'https://papi.hmhco.com/ids-grid-api',
  hcpIdentityApiGateway: 'https://hapi.hmhco.com/hcp-identity-api-gateway',
  edsAuthorizationCode:
    'https://hapi.hmhco.com/edcore/eds-login/login/authorization-code/callback',
  susAuth: 'https://www.hmhco.com/api/authorization',
  authorizationApi: 'https://www.hmhco.com/api/authorization',
  edsInitUrl: 'https://hapi.hmhco.com/edcore/eds-login/login/initializeUri',
  ampLogin: 'https://login.mapnwea.org/ui/login',
  nweaIssuer: 'https://hapi.hmhco.com/edcore/eds-login',
  nweaStartUrl: 'https://start.nwea.org',
};

module.exports = prodNweaConfig;
